import { axiosInstance } from '@/lib/axios';
import { FileProcessingStatus } from './types';

type Props = {
  companyId: string
  fileId?: string|number
  taskId: string
}

export function getFileProcessingStatus ({ companyId, fileId, taskId }: Props) {
    return axiosInstance.get<FileProcessingStatus>(`/api/${companyId}/fileProcessing/status?&id=${fileId}&taskId=${taskId}`);
}
